export default "__VITE_ASSET__Bvz0tJvW__"